<template>
    <div>
        <Button :label="$t('messages.dataPolicy')" name="enviar"
            style="width:200px;margin:0px auto;justify-content:center" @click="handleOnClick">{{ $t("messages.dataPolicy") }}</Button>
        <Dialog :header="$t('messages.dataPolicy')" :visible.sync="displayBasic2" :modal="true">
            <div style="width: 80vw;height: 80vh;">
                <object data="/assets/files/ppdp.pdf" type="application/pdf" width="100%" height="100%">
                    <p>{{ $t("messages.noPdfPlugin1") }} <a href="/assets/files/ppdp.pdf">{{ $t("messages.noPdfPlugin2") }}</a></p>
                </object>
            </div>
            <template #footer>
                <Button :label="$t('messages.close')" icon="pi pi-check" @click="closeBasic2" autofocus />
            </template>
        </Dialog>
    </div>
</template>

<script>
export default {
    name: "boton_politicas",
    data() {
        return {
            displayBasic2: false,
        }
    },
    methods: {
        handleOnClick() {
            this.displayBasic2 = true;
        },
        closeBasic2() {
            this.displayBasic2 = false;
        }
    },
}
</script>

<style scoped>
.boton-politica {
    background-color: #083078;
    border: 1px solid white;
    color: white;
    width: fit-content;
    padding: 20px;
}
</style>